import modalStore from 'shared/ui/Modal/store/modalStore'

import { RCS_EXAMPLE_CONTENT, type IRcsExampleKey } from './exampleContent'
import { RcsExampleModalContent } from './RcsExampleModalContent'

const MODAL_ID = 'rcsExampleModal'

export const openRcsExampleModal = (key: IRcsExampleKey) => {
  const { title, content } = RCS_EXAMPLE_CONTENT[key]

  modalStore.addModal({
    id: MODAL_ID,
    width: 540,
    title,
    ModalContent: () => <RcsExampleModalContent example={content} />,
    primaryAction: {
      text: 'Done',
      onAction: () => modalStore.closeModal(MODAL_ID),
    },
    showCloseButton: false,
  })
}
